import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../models/error.model';
import { IMainApiService } from '../../../../../services/api.service';
import { IApiService } from '../../../../../services/api.service.base';

export class UpdateWorkspaceTimeZoneRequest {
  workspaceId: string;
  timeZoneOffset: number;

  constructor(workspaceId: string, timeZoneOffset: number) {
    this.workspaceId = workspaceId;
    this.timeZoneOffset = timeZoneOffset;
  }
}

export interface IUpdateWorkspaceTimeZoneService {
  updateWorkspaceTimeZone(request: UpdateWorkspaceTimeZoneRequest): Promise<void>;
}

export namespace IUpdateWorkspaceTimeZoneService {
  export const $: interfaces.ServiceIdentifier<IUpdateWorkspaceTimeZoneService> = Symbol('UPDATE_WORKSPACE_TIMEZONE_SERVICE');
}

@injectable()
export class UpdateWorkspaceTimeZoneService implements IUpdateWorkspaceTimeZoneService {
  private readonly url = '/workspace/updateTimeZone';

  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  async updateWorkspaceTimeZone(request: UpdateWorkspaceTimeZoneRequest): Promise<void> {
    const result = await this.apiService.postAsync<UpdateWorkspaceTimeZoneRequest>(this.url, request);
    if (result instanceof ACDLError) {
      throw result;
    }
  }
}
